module.exports = __webpack_public_path__ + "media/images/icon/ico_top_flow06-675a6589166e7b357d655b4e12471a4f.svg";